import React from 'react';
import { DownloadLinksList } from 'Components/frameworks/download-links-list/DownloadLinksList';
import type { DownloadLinksListItem } from 'Components/frameworks/download-links-list/DownloadLinksList';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { castAs } from 'Src/types/cast-helpers';
type Props = {
  downloadLabel: string;
  id?: string;
  resort: {
    factSheetUrl: string;
  };
  resortId: string;
  text?: string;
};
export const ProductInformationSummaryLine = ({
  downloadLabel,
  id,
  resort: { factSheetUrl },
  resortId,
  text,
}: Props) => {
  if (!factSheetUrl) {
    return null;
  }

  const links = [
    {
      label: downloadLabel,
      target: '_blank',
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'CTA_download_factsheet',
        labelGA: resortId,
      },
      url: factSheetUrl,
    },
  ];
  return (
    <SiteContainer className="Line Line-DownloadLinksList" id={id}>
      <DownloadLinksList
        className="shadow-bottom bg-white py-20"
        links={castAs<DownloadLinksListItem[]>(links)}
        text={text}
      />
    </SiteContainer>
  );
};
